import classNames from 'clsx'
import styles from './Slideshow.module.scss'

import type { ContentBlock as ContentBlockType } from '../../../../shared/types'
import { parentMeta } from '../type'

import useSlideshow from './useSlideshow'
import { renderContent } from '../renderContent'

interface SlideshowProps {
  contentBlock: ContentBlockType
  parentMeta?: parentMeta
  filePath?: string
  autoplayDelay?: number
}

const Slideshow = (props: SlideshowProps) => {
  const { parentMeta, filePath, contentBlock, autoplayDelay } = props
  const content = contentBlock.content || []

  const { currentSlide } = useSlideshow({ contentBlock, autoplayDelay })

  return (
    <div className={styles.slideshowRoot}>
      {/* iterate over all content items, and render respective Content Types */}
      {content.map((item, index) => (
        <div
          key={index}
          className={classNames(styles.slide, {
            [styles.active]: index === currentSlide,
            [styles.inactive]: index !== currentSlide,
          })}
        >
          {index === currentSlide &&
            renderContent({ content: item, filePath, parentMeta, index })}
        </div>
      ))}
    </div>
  )
}

export default Slideshow
